import React from 'react';

import Checkout from './CheckOut/Checkout';

const Basket = () => {
    return <Checkout/>
}
export default Basket;

